import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Home from '../components/Home/Home.jsx';
import Edmond from '../components/edi/edi.jsx';

// Component to handle first-time visitors
const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Always redirect to home
    navigate('/home');
  }, [navigate]);

  return null;
};

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<RootRedirect />} />
        <Route path='/home' element={<Home />} />
        <Route path='/payment' element={<Edmond />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
